import { SuccessRequestAction } from "../../Middleware/apiMiddleware";
import { CustomizationState } from "../types";
import { CustomizationActionTypes } from "./actions/loadCustomization";

type CustomizationActions = SuccessRequestAction<
    CustomizationActionTypes.LOAD_CUSTOMIZATION_SUCCESS,
    CustomizationState
>;

export const customizationReducer = (
    state: CustomizationState = {},
    action: CustomizationActions
): CustomizationState => {
    switch (action.type) {
        case CustomizationActionTypes.LOAD_CUSTOMIZATION_SUCCESS:
            return {
                ...state,
                ...action.payload,
                __isCustomizationLoaded: true,
            };
        default:
            return state;
    }
};
